<template>
    <b-row>
        <b-col cols="12" md="12">
            <component-header
                title="Concern List"
                :hasSearch="false"
                :hasCreate="true"
                :hasReload="true"
                :isLoading="loading"
                @create-press="openCreateModal"
                @reload-data="reloadPage"
            >
                <template #heading-before-search>
                    <div class="concern-filters-wrapper mr-2">
                        <b-form-select
                            v-model="selectConcern"
                            :options="options"
                            class="concern-filter-select mr-2 mb-2 mb-md-0"
                            @change="onChangeConcernType"
                        />

                        <div
                            v-if="selectConcern === 'name'"
                            class="search-input-wrapper header-search-wrapper mr-2 mb-2 mb-md-0"
                        >
                            <Vue-Simple-Suggest
                                class="search-input-with-icon w-100"
                                :nullable-select="true"
                                v-model="searchConcernInput"
                                @keyup.enter.native="searchConcernResult()"
                                :debounce="1000"
                                display-attribute="name"
                                value-attribute="_id"
                                placeholder="Search Concern Name"
                            ></Vue-Simple-Suggest>
                            <button
                                class="search-icon-inside"
                                @click="searchConcernResult()"
                                type="button"
                            >
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                        <b-form-select
                            v-else
                            v-model="selectConcernType"
                            :options="optionsConcern"
                            class="concern-filter-select mr-2 mb-2 mb-md-0"
                            @change="searchConcernTypeResult"
                        />
                    </div>
                </template>
            </component-header>
            <b-modal
                id="create-concern-modal"
                ref="create-concern-modal"
                title="Create Concern"
                centered
                hide-footer
            >
                <b-form-group label="Concern Name" class="mb-3">
                    <b-form-input
                        type="text"
                        placeholder="Enter Concern Name"
                        v-model="concernInput"
                        @keyup.enter="showCreateConsern"
                    />
                </b-form-group>

                <b-form-group label="Concern Type" class="mb-3">
                    <b-form-radio-group
                        id="radio-group-2"
                        v-model="selected"
                        name="radio-sub-component"
                        class="d-flex"
                    >
                        <b-form-radio value="system" class="mr-3"
                            >System</b-form-radio
                        >
                        <b-form-radio value="custom">Custom</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <div class="text-right mt-4">
                    <b-button
                        variant="secondary"
                        class="mr-2"
                        @click="closeCreateModal"
                        >Cancel</b-button
                    >
                    <b-button variant="primary" @click="showCreateConsern"
                        >Save</b-button
                    >
                </div>
            </b-modal>
        </b-col>
        <b-col cols="12" md="12">
            <b-card class="custome-card">
                <div>
                    <b-table
                        class="professional-stacked-table"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive="sm"
                        stacked="md"
                        :items="concernOptionData"
                        :fields="concernListData"
                        :current-page="currentPage"
                        :per-page="perPage"
                        @filtered="onFilter"
                        thead-class="header"
                        show-empty
                        :busy="loading"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(createdAt)" slot-scope="data">
                            <div>
                                {{
                                    moment(String(data.item.createdAt)).format(
                                        "DD/MM/YYYY hh:mm A",
                                    )
                                }}
                            </div>
                        </template>
                        <template slot="cell(action)" slot-scope="data">
                            <div
                                class="d-flex text-center justify-content-center"
                            >
                                <div>
                                    <b-button
                                        size="sm"
                                        class="button-circle"
                                        variant="danger"
                                        @click="deleteConcernlist(data.item)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                </div>
                            </div>
                        </template>
                        <template slot="empty">
                            <div v-if="loading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="pagination-wrapper">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="concernOptionData.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import { mapState } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Vue from "vue";
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader/index.vue";
Vue.prototype.moment = moment;
export default {
    name: "concern",
    data() {
        return {
            concernInput: "",
            selected: "system",
            filterCount: 0,
            loading: false,
            perPage: 10,
            currentPage: 1,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            sortBy: "createdAt",
            sortDesc: true,
            concernListData: [
                {
                    key: "name",
                    label: "Concern Name",
                },
                {
                    key: "type",
                    label: "Concern Type",
                },
                {
                    key: "createdAt",
                    label: "Created Date",
                },
                {
                    key: "action",
                    label: "Action",
                    class: "text-center",
                },
            ],
            searchConcernInput: "",
            selectConcern: "type",
            options: [
                { text: "Concern Name", value: "name" },
                { text: "Concern Type", value: "type" },
            ],
            selectConcernType: "custom",
            optionsConcern: [
                { text: "All Types", value: "" },
                { text: "System", value: "system" },
                { text: "Custom", value: "custom" },
            ],
        };
    },
    components: {
        VueSimpleSuggest,
        ebSelect,
        ComponentHeader,
    },
    computed: {
        ...mapState({
            concernOptionData: (state) => state.concern.concernOptionData,
        }),
    },
    methods: {
        onChangeConcernType() {
            this.searchConcernInput = "";
            this.selectConcernType = "";
        },
        openCreateModal() {
            this.concernInput = "";
            this.selected = "system";
            this.$refs["create-concern-modal"].show();
        },
        closeCreateModal() {
            this.$refs["create-concern-modal"].hide();
        },
        async showCreateConsern() {
            if (this.concernInput != "") {
                let payload = {
                    name: this.concernInput,
                    type: this.selected,
                    active: true,
                };
                await this.$store.dispatch("concern/concernCreate", payload);
                this.$swal({
                    title: "success!",
                    text: "Your Concern is Submitted successfully!",
                    type: "success",
                });
                this.closeCreateModal();
                this.reloadPage();
                this.concernInput = "";
                this.selected = "system";
            } else {
                this.$swal({
                    title: "Error!",
                    text: "Please Enter Concern Name!",
                    type: "warning",
                });
            }
        },

        async deleteConcernlist(data) {
            this.$swal({
                title: "Delete this Concern?",
                text: "Are you sure? This will be Remove?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.loading = true;
                    this.$store
                        .dispatch("concern/ConcernDeleteAction", data._id)
                        .then((result) => {
                            this.$swal({
                                type: "success",
                                title: "Success",
                                text: "Concern Deleted Successfully!",
                            });
                            this.reloadPage();
                            this.loading = false;
                        });
                }
            });
        },
        async fetchConcerns(name = "", type = "") {
            this.loading = true;
            let payload = {
                name: name,
                type: type,
            };
            await this.$store.dispatch("concern/concernFilterAction", payload);
            this.loading = false;
        },
        async searchConcernResult() {
            await this.fetchConcerns(
                this.searchConcernInput,
                this.selectConcernType.value || "",
            );
        },
        async searchConcernTypeResult() {
            await this.fetchConcerns(
                this.searchConcernInput,
                this.selectConcernType || "",
            );
        },
        async reloadPage() {
            await this.fetchConcerns("", "");
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
    },
    async mounted() {
        await this.fetchConcerns("", "");
    },
};
</script>
<style scoped>
.card.custome-card {
    border: 1px solid #ddd;
    border-radius: 12px;
}

.concern-filters-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
}

.concern-filter-select {
    min-width: 140px;
}

.concern-filter-select :deep(select),
.concern-filter-select :deep(.custom-select) {
    height: 34px !important;
    min-height: 34px !important;
    padding: 0 12px;
    border-radius: 8px;
    border: 1px solid var(--slate-200);
    font-size: 14px;
}

.concern-filters-wrapper .search-input-wrapper {
    width: auto;
    min-width: 220px;
    max-width: 260px;
    flex: 0 0 auto;
}

@media (max-width: 767.98px) {
    .concern-filters-wrapper {
        flex-wrap: wrap;
    }

    .concern-filters-wrapper .search-input-wrapper,
    .concern-filter-select {
        min-width: 100%;
        max-width: 100%;
        flex: 1 1 100%;
    }
}

.search-icon-btn {
    background-color: transparent;
}

.search-input-wrapper {
    position: relative;
    width: 100%;
}

.search-input-with-icon {
    width: 100%;
}

.search-input-wrapper ::v-deep .vue-simple-suggest input {
    padding-right: 35px !important;
    height: 38px !important;
    min-height: 38px !important;
}

.search-icon-inside {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-60%);
    background: transparent;
    border: none;
    color: #6c757d;
    cursor: pointer;
    z-index: 10;
    font-size: 18px;
}

.search-icon-inside:hover {
    color: #495057;
}

.search-icon-inside:focus {
    outline: none;
}

.reload-icon {
    font-size: 15px;
}

.refresh-btn {
    height: 37px;
    min-height: 37px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.concern-type-label {
    margin-bottom: 0;
    margin-right: 0.5rem;
    margin-top: -3px;
    white-space: nowrap;
    flex-shrink: 0;
}

@media (min-width: 768px) {
    .concern-type-label {
        margin-right: 1rem;
    }
}

.concern-name-input {
    margin-left: 30px;
}

@media (max-width: 767.98px) {
    .concern-name-input {
        margin-left: 0;
    }
}

.header-filter-select {
    min-width: 150px;
    max-width: 200px;
}
.header-filter-select ::v-deep .vs__dropdown-toggle {
    border-radius: 4px;
    border: 1px solid #ced4da;
    height: 38px;
    padding: 0;
    background: #fff;
}
.header-filter-select ::v-deep .vs__search::placeholder,
.header-filter-select ::v-deep .vs__dropdown-toggle,
.header-filter-select ::v-deep .vs__dropdown-menu {
    border-color: #ced4da;
    font-size: 14px;
    color: #495057;
}
.header-filter-select ::v-deep .vs__selected {
    margin: 4px 7px 0;
}
.header-search-wrapper {
    min-width: 200px;
    max-width: 250px;
}
</style>
